import script from "./DRTPlot.vue?vue&type=script&setup=true&lang=ts"
export * from "./DRTPlot.vue?vue&type=script&setup=true&lang=ts"

import "./DRTPlot.vue?vue&type=style&index=0&id=0bccd6b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\t.matsutake\\workspace\\vue_ws\\EISStudio\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bccd6b6"]])

export default __exports__